module.exports = __webpack_public_path__ + "img/telegram.9a82fd4a.svg";